<template>
    <div class="final-slide">
        <div
            class="side half p-l"
            :class="[center ? 'center-y' : 'p-t']"
        >
            <transition name="fade" appear>
                <img
                    v-if="$parent.content5Visible"
                    class="illu"
                    :src="require('@/assets/endscreen_illu.png')"
                    alt="Medienführerschein Bayern"
                >
            </transition>
        </div>
        <div
            class="side half p-x"
            :class="[center ? 'center-y' : 'p-t']"
        >
            <TextBox v-if="$parent.content1Visible" class="text-thin">
                Alle Praxisbeispiele und viel Wissenswertes für deinen pädagogischen Alltag
                findest du im Medienführerschein Bayern für den Elementarbereich –
                kostenlos als Ordner bestellbar oder downloadbar unter:<br><br>
                <a target="_blank" href="https://www.medienfuehrerschein.bayern/Angebot/17_Elementarbereich.htm">
                    <b>www.medienfuehrerschein.bayern</b>
                </a>
            </TextBox>
            <SlideInTransition v-show="$parent.content3Visible" from="right">
                <div>
                    <h2>
                        Viel Spaß beim Ausprobieren!
                    </h2>
                </div>
            </SlideInTransition>
        </div>
        <slot />
    </div>
</template>

<script>

export default {
    name: 'FinalSlide',
    props: {
        center: {
            type: Boolean,
            default: true
        }
    },
    mounted()
    {
        this.$parent.setNextButtonActive(
            true,
            'Zur Startseite',
            () => this.$router.push({name: 'home'})
        );
        const {module} = this.$route.params;
        if (module)
        {
            this.$store.commit('finishModule', module);
        }
    }
};
</script>

<style lang="scss" src="./FinalSlide.scss" />

